import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { receiptsEnabled, storage } from './firebase';
import { newId } from './db';

/**
 * Phone cameras produce 3–8MB files. Nobody needs that to read a bill, and it
 * is the difference between staying inside a free storage tier and not.
 */
export async function compressImage(file: File, maxEdge = 1600, quality = 0.72): Promise<Blob> {
  const bitmap = await createImageBitmap(file);
  const scale = Math.min(1, maxEdge / Math.max(bitmap.width, bitmap.height));
  const w = Math.round(bitmap.width * scale);
  const h = Math.round(bitmap.height * scale);

  const canvas = document.createElement('canvas');
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext('2d');
  if (!ctx) return file;
  ctx.drawImage(bitmap, 0, 0, w, h);
  bitmap.close?.();

  const blob = await new Promise<Blob | null>((resolve) =>
    canvas.toBlob(resolve, 'image/jpeg', quality)
  );
  return blob ?? file;
}

export interface UploadedReceipt { url: string; path: string }

export async function uploadReceipt(groupId: string, file: File): Promise<UploadedReceipt> {
  if (!receiptsEnabled) throw new Error('Receipts are turned off in this build.');
  const blob = await compressImage(file);
  const path = `receipts/${groupId}/${newId()}.jpg`;
  const r = ref(storage, path);
  await uploadBytes(r, blob, { contentType: 'image/jpeg' });
  return { url: await getDownloadURL(r), path };
}

export { receiptsEnabled };
